import { Fragment } from 'react';
import { HR } from 'foundations-components/transitional/components/HR';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { validateAuthStep } from '../../../stepRenderer';
import { IntroStep } from './steps/IntroStep';
import { LowLevelFinishAuthButton } from './LowLevelFinishAuthButton';
import { ModalOrInlineLayout } from '../ModalOrInlineLayout';
import { useLowLevelAuthFlowMachine } from './LowLevelAuthFlowMachineContext';
import { useAuthFlowActions } from './hooks';
import { AuthErrorSection, AuthStepItemsList } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NO_OP_INTRO = {
  render: null
};
const defaultUseIntroConfig = () => NO_OP_INTRO;
export function InlineAuthFlowLayout({
  isModal,
  header,
  authFlowType,
  useIntroScreen,
  processError,
  errorContext,
  onCancel,
  onSelectExistingAccount,
  disabled
}) {
  const {
    state,
    send
  } = useLowLevelAuthFlowMachine();
  const {
    authConfig,
    params,
    authError
  } = state.context;
  const {
    appName,
    authFlow
  } = authConfig;
  const {
    handleParamChange
  } = useAuthFlowActions();
  const introConfig = (useIntroScreen !== null && useIntroScreen !== void 0 ? useIntroScreen : defaultUseIntroConfig)({
    type: authFlowType,
    appName,
    onDone: () => send({
      type: 'GO_TO_NEXT_STEP'
    }),
    onCancel,
    disabled,
    onSelectExistingAccount
  });
  const allStepsValid = authFlow.steps.every(step => validateAuthStep(step, params));
  return /*#__PURE__*/_jsx(ModalOrInlineLayout, {
    isModal: isModal,
    header: header,
    body: /*#__PURE__*/_jsxs(Section, {
      paddingBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(AuthErrorSection, {
        appName: appName,
        authError: authError,
        errorContext: errorContext,
        processError: processError
      }), introConfig.render ? introConfig.render() : /*#__PURE__*/_jsx(IntroStep, {
        type: authFlowType,
        appName: appName
      }), /*#__PURE__*/_jsx(View, {
        children: authFlow.steps.map((step, ix) => /*#__PURE__*/_jsxs(Fragment, {
          children: [ix > 0 ? /*#__PURE__*/_jsx(HR, {
            distance: "large"
          }) : null, /*#__PURE__*/_jsxs(View, {
            marginBlockEnd: ix === authFlow.steps.length - 1 ? '1000' : undefined,
            children: [step.title ? /*#__PURE__*/_jsx(Text, {
              as: "h5",
              marginBlockEnd: "200",
              children: step.title
            }) : null, /*#__PURE__*/_jsx(View, {
              marginInlineStart: "400",
              children: /*#__PURE__*/_jsx(View, {
                paddingInlineStart: "50",
                children: /*#__PURE__*/_jsx(AuthStepItemsList, {
                  items: step.items,
                  params: params,
                  onParamChange: handleParamChange
                })
              })
            })]
          })]
        }, ix))
      })]
    }),
    footer: /*#__PURE__*/_jsx(ButtonWrapper, {
      paddingInlineStart: "400",
      paddingBlockStart: "300",
      children: /*#__PURE__*/_jsx(View, {
        paddingInlineStart: "50",
        children: /*#__PURE__*/_jsx(LowLevelFinishAuthButton, {
          disabled: disabled || !allStepsValid || !!introConfig.connectButtonDisabled,
          label: introConfig.connectButtonLabel
        })
      })
    })
  });
}